import { each } from "jquery";
import * as intlTelInput from 'intl-tel-input';
import * as intlTelInputUtils from 'intl-tel-input/build/js/utils.js';

class FormMaps {
    constructor() {
        this.branches = [];
        //PHONE NUMBER
        this.itiMaps = null;
        this.currentCountry = 'es'; //default
        this.onlyCountries = [this.currentCountry];
        this.map = null;
        this.userLocation = null;
        this.infowindow = null;
        this.lastBlockPosition = 0;
        this.bindSearch();
        this.bindSearchIntro();
        this.bindCollapseElement();
    }

    async getBranches(location) {
        var that = this;
        this.branches = [];
        if(!location) {  
            $('#collapseWorkshop #branches-list-map #wf-map-branches-block').hide();   
            this.userLocation = await this.getUserLocation();
            $('#collapseWorkshop #branches-list-map #wf-map-branches-block').show();
        } else {
            this.userLocation = location;
        }

        var data = "pavh="+$('#dealer').val();
        if(this.userLocation != null) {
            data += '&latitude='+this.userLocation.lat+'&longitude='+this.userLocation.lng;
        }
        if ($('#official-branches').val() === '1'){
            data += '&brand_id='+$('#appointment_vehicle_brand').val();
        } 

        $('#collapseWorkshop #wf-map-branches-block').show();

        $('#collapseWorkshop .branches-list-block #wf-total-list').html('');
        $('#collapseWorkshop .branches-list-block').hide();
        $('#collapseWorkshop .branches-list-block #wf-total-branches-found').html('');
        $('#collapseWorkshop .branch-list-loader .loader-branches-row .wrap-loader').show();
        $('#collapseWorkshop #branches-list-map #wf-map-branches-block').hide();
        $('#collapseWorkshop .branch-list-container').hide();
        $.ajax({
            url: $('#url-base-lang').val()+$('#dealer').val()+"/"+"form/branchList",
            data: data,
            type:'POST',
            success: function(result) {
                if(result!='-1' && result!='') {
                    var IS_JSON = true;
                    try{
                        var obj = JSON.parse(result);
                    }catch(err){
                        IS_JSON = false;
                    } 
                    if(IS_JSON){
                        $('#wf-error-search .error').hide();
                        $('#wf-error-search .error .error-msg').html('');

                        obj.forEach(element => {
                            if(element.latitude!='' && element.longitude) {
                                that.branches.push(element);
                            }
                        });
                        that.branchesSearcher = that.branches;
                        if(that.branches.length>0) {
                            that.paintBranches(that.branches);
                        } else {
                            //show message no branches
                        }
                    }
                } else {
                    $('#collapseWorkshop .branch-list-loader .loader-branches-row .wrap-loader').hide();
                    $('#wf-error-search').show();
                    $('#wf-error-search .error').show();
                    $('#wf-error-search .error .error-msg').html($('#wf-branch-not-found').val());

                    $('#btn-branch-map-confirm').prop('disabled', true);
                }
            }
        })
    }

    async getUserLocation() {
        var that = this;
        return new Promise(function(resolve, reject) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {
                    var pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    resolve(pos) // successfully fill promise OÉ OÉ
                }, function() {
                    that.handleLocationError(true, that.infoWindow);
                });
            } else {
                // Browser doesn't support geolocation
                that.handleLocationError(false, that.infoWindow);
            }
        })
    }
    
    async paintBranches(elements) {
        var that = this;
        $('#collapseWorkshop #branches-list-map #wf-map-branches-block').show();
        $('#collapseWorkshop .branch-list-loader .loader-branches-row .wrap-loader').hide();
        $('#collapseWorkshop .branches-list-block').show();
        $('#collapseWorkshop .branch-list-container').addClass('d-flex');

        var infowindow = new google.maps.InfoWindow();
        var bounds = new google.maps.LatLngBounds();

        var latlng = new google.maps.LatLng(this.userLocation.lat, this.userLocation.lng);
        var mapOptions = {
			center: latlng,
			zoom: 7,
            mapTypeId: 'roadmap'
        }
        this.map = new google.maps.Map(document.getElementById('wf-map-branches'), mapOptions);
    
        for (var i = 0; i < elements.length; i++) {
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(elements[i].latitude, elements[i].longitude),
                map: that.map,
                title: elements[i].name.toUpperCase()
            });
            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {
                    infowindow.setContent(elements[i].name.toUpperCase());
                    infowindow.open(that.map, marker);
                    that.map.setZoom(12);
                    that.map.setCenter(marker.getPosition());
                    that.selectBranchFromMap(elements[i], true);
                }
            })(marker, i));
        }

        this.map.setZoom(7);
        this.paintBranchesBlock(elements);
    }

    paintMapMarker(element) {
        var location = new google.maps.LatLng(element.latitude, element.longitude);
        this.map.setCenter(location);
        this.map.setZoom(17);
    }

    phoneInput(element) {
        var that = this;
        if($('#country-code').length>0 && $('#country-code').val()!='') {
            this.currentCountry = $('#country-code').val();
            this.onlyCountries = [this.currentCountry];
            this.itiMaps = intlTelInput(document.querySelector(element), {
                initialCountry: that.currentCountry,
                nationalMode: true,
                autoPlaceholder: "off",
                utilsScript: "../../build/js/utils.js"
            });
        } else {
            // call endpoint
            $.getJSON('https://extreme-ip-lookup.com/json/')
            .done(function(data) {
                this.currentCountry = data.countryCode.toLowerCase();
                this.onlyCountries = []
                this.onlyCountries.push(currentCountry);
                this.itiMaps = intlTelInput(document.querySelector(element), {
                    initialCountry: that.currentCountry,
                    nationalMode: true,
                    autoPlaceholder: "off",
                    utilsScript: "../../build/js/utils.js"
                });
            })
            .fail(function() {
                this.itiMaps = intlTelInput(document.querySelector(element), {
                    initialCountry: that.currentCountry,
                    nationalMode: true,
                    autoPlaceholder: "off",
                    utilsScript: "../../build/js/utils.js"
                });
            });  
        }
    }

    selectBranchFromMap(element, init) {
        $('.branch-selected .branch-select-container').html('');
        $('.branch-selected').show();
        var code = (element.code!='' ? (element.code+" - ") : " ");
        var block = '<div class="col-lg-12 col-md-12 wf-branch-list wf-list-block selected wf-list-block-'+element.id+'" id="wf-list-block-'+element.id+'" data-id="'+element.id+'" data-slot="'+element.slot_duration+'">';
        block += '<div class="w-100" wf-id="' + element.id + '">';
        block += '<div class="wf-list-row wf-list-fc w-100 row"><div class="wf-list-name col-12">' + element.name + '</div></div>';
        block += '<div class="w-100 row wf-list-subtitle"><div class="col-12 wf-list-row wf-list-sc">' + element.address + '</div></div>';
        block += '<input type="hidden" id="ws-id" name="ws-id" value="'+element.id+'"/>';
        block += '</div>';
        block += '<div class="row w-100 wf-list-extra">';
        block += '<div class="col-12">';
        block += '<div class="w-100">'+ code + element.city+ ', ' + element.state +'</div>';
        block += '<div class="w-100 mobile-field-disabled">';
        block += '<input type="text" id="mobile-field-'+element.id+'" disabled class="form-control mobile-field" value="'+element.telephone+'"/>';
        block += '</div>';
        block += '</div></div>';
        $('.branch-selected .branch-select-container').append(block);
        if(init == true) {
            $('html, body').animate({
                scrollTop: $("#appointment_workshop").offset().top - 20
            }, 1000);
        }  
        $('#wf-total-list .wf-list-block-created').each(function() {
            $(this).removeClass('selected');
            if(element.id !== $(this).attr('data-id')) {
                $(this).find('.collapse').removeClass('show');
            } else {
                $(this).find('.collapse').addClass('show');
                $(this).addClass('selected');
            }
        });

        if(init == true) {
            $('#wf-total-list').scrollTop(0);
            $('#wf-total-list').animate({
                scrollTop: $('#wf-total-list #wf-list-block-'+element.id).offset().top - $('#wf-total-list').offset().top
            }, 50);
        }

        $('#btn-branch-map-confirm').prop('disabled', false);

        this.phoneInput('#'+$('.branch-selected .mobile-field').attr('id'));
        this.paintMapMarker(element);
    }

    paintBranchesBlock(elements) {
        var that = this;
        var string = $('#wf-branch-total-found-string').val();
        var stringFound = string.replace("#", elements.length);
        $('.branches-list-block #wf-total-branches-found').html(stringFound);
        elements.forEach(element => {
            var code = (element.code!='' ? (element.code+" - ") : " ");
            var block = '<div class="col-lg-12 col-md-12 d-flex wf-list-block-created" id="wf-list-block-'+element.id+'" data-id="'+element.id+'">';
            block += '<div class="col-11 wf-branch-list" data-id="'+element.id+'"><div class="w-100" wf-id="' + element.id + ' aria-expanded="true" aria-controls="collapseWorkshop_'+element.id+'">';
            block += '<div class="wf-list-row wf-list-fc w-100 row"><div class="col-1"><i class="fas fa-map-marker-alt"></i></div><div class="wf-list-name col-10">' + element.name + '</div></div>';
            block += '<div class="w-100 row wf-list-subtitle"><div class="col-1"></div><div class="col-10 wf-list-row wf-list-sc">' + element.address + '</div><div class="col-1"></div></div>';
            block += '</div>';
            block += '<div class="wf-list-row-collapsed" id="collapseWorkshop_'+element.id+'">';
            block += '<div class="row w-100 wf-list-extra"><div class="col-1"></div>';
            block += '<div class="col-10">';
            block += '<div class="w-100">'+ code + element.city+ ', ' + element.state +'</div>';
            block += '<div class="w-100 mobile-field-disabled">';
            block += '<input type="text" id="mobile-field-'+element.id+'" disabled class="form-control mobile-field" value="'+element.telephone+'"/>';
            block += '</div>';
            block += '</div><div class="col-1"></div>';
            block += '</div></div></div>';
            block += '<div class="col-1 text-center collapse-element collapse-element-' + element.id + '" data-collapse="' + element.id + '"><i class="fas fa-angle-down"></i></div>';
            block += '</div>';
            $('.branches-list-block #wf-total-list').append(block);
        });
    
        $('.wf-list-row-collapsed .mobile-field').each(function(element) {
            that.phoneInput('#'+$(this).attr('id'));
        });
        this.selectBranchFromMap(elements[0], false);
        this.bindWFList();
        this.bindCollapseElement();
    }

    bindWFList() {
        var that = this;
        $(".wf-branch-list").on("click", function() {
            $('#appointment-categories').empty();
            $('#collapseReason').collapse('hide');
            $('#appointment_reason').addClass('section-off').addClass('form-block-inactive').removeClass('form-block-active');
            $('#appointment_reason .question-row-collapse').show();
            $('#appointment_reason .question-row-collapse .form-answer').hide();
            $('#appointment_reason .question-row-collapse .form-question').show();
            $('#appointment_reason .question-row-collapse .form-answer').addClass('content-collapsed');
            $('#appointment_reason .form-text-left').removeClass('content-collapsed');
            $('#appointment_reason .appointment-budget .budget-items').empty();
            $('#appointment_reason .appointment-budget .budget-price-subtotal .value').html('');
            $('#appointment_reason .appointment-budget .budget-price-tax .value').html('');
            $('#appointment_reason .appointment-budget .budget-price-total .value').html('');
            $('#appointment_reason .appointment-budget .b-body-empty').show();
            $('#appointment_reason .appointment-budget .b-body-content').addClass('d-none');
            $('#appointment_reason .categories-content').empty();
            $('#collapseReasonMsg').removeClass('active');
            $('#reason-comments-desktop').hide();
            $('#reason-discount-codes-desktop').hide();
            $('#appointment-reason-continue').hide();
            if(window.innerWidth<1000) {
                $('.navbar-price-movile').hide();
                $('.navbar-price-desktop').show();
                $('.navbar-price-movile #navbar-price').hide();
                $('.page-body').addClass('extra-padding-top');
            } else {
                $('.navbar-price-desktop').hide();
                $('.navbar-price-movile').show();
                $('.navbar-price-desktop #navbar-price').hide();
                $('.page-body').removeClass('extra-padding-top');
            }
            $('.brand__navbar #navbar-price .prive-value').html('');

            if($('#appointment_reason .question-mobile').is(':visible')) {
                $('#appointment_reason .form-question').show();
                $('#appointment_reason .question-mobile').hide();
                $('#appointment_reason .question-mobile .form-answer').hide();
            } else {
                $('#appointment_reason .question-desktop').hide();
            }

            that.innactiveSection('#appointment_reason');

            if($('#appointment_advisor').length>0) {
                $('#collapseAdvisor').collapse('hide');
                $('#appointment_advisor').addClass('section-off').addClass('form-block-inactive').removeClass('form-block-active');
                $('#appointment_advisor .question-row-collapse').show();
                $('#appointment_advisor .question-row-collapse .form-answer').hide();
                $('#appointment_advisor .question-row-collapse .form-question').show();
                $('#appointment_advisor .question-row-collapse .form-answer').addClass('content-collapsed');
                $('#appointment_advisor .form-text-left').removeClass('content-collapsed');
                $('#advisor_id').val('');
                $('#advisor_name').val('');
                $('#advisor_slot').val('');
                $('#appointment-advisor-list .form-icon-advisor-btn-padding').each(function() {
                    $(this).find('.form-btn-icons-advisor-text').removeClass('advisor-selected');
                });
                that.innactiveSection('#appointment_advisor');  
            } 

            $('#collapseSchedule').collapse('hide');
            $('#appointment_schedule').addClass('section-off').addClass('form-block-inactive').removeClass('form-block-active');
            $('#appointment_schedule .form-question').hide();
            $('#appointment_schedule .question-row-collapse').show();
            $('#appointment_schedule .question-row-collapse .form-answer').hide();
            $('#appointment_schedule .question-row-collapse .form-answer').html('');
            $('#appointment_schedule .question-row-collapse .form-question').show();
            $('#appointment_schedule .question-row-collapse .form-answer').addClass('content-collapsed');
            $('#appointment_schedule .form-text-left').removeClass('content-collapsed');
            that.innactiveSection('#appointment_schedule');

            $('#collapseDatos').collapse('hide');
            $('#appointment_datos').addClass('section-off').addClass('form-block-inactive').removeClass('form-block-active');
            $('#appointment_datos .form-question').hide();
            $('#appointment_datos .question-row-collapse').show();
            $('#appointment_datos .question-row-collapse .form-answer').hide();
            $('#appointment_datos .question-row-collapse .form-answer').html('');
            $('#appointment_datos .question-row-collapse .form-question').show();
            $('#appointment_datos .question-row-collapse .form-answer').addClass('content-collapsed');
            $('#appointment_datos .form-text-left').removeClass('content-collapsed');
            that.innactiveSection('#appointment_datos');

            if($(this).parent().hasClass('selected')) {
                $(this).parent().removeClass('selected');
            } else {
                var element = $(this);
                $('.wf-branch-list').each(function() {
                    $(this).parent().removeClass('selected');
                    if($(this).attr('data-id') != $(element).attr('data-id')) {
                        $(this).find('.wf-list-row-collapsed').hide();
                    } else {
                        $(this).find('.wf-list-row-collapsed').show();
                    }
                });
                $(this).parent().addClass('selected');
                $('#ws-id').val($(this).attr('data-id'));
                var wsId = $(this).attr('data-id');
                var element = that.branches.find(o => o.id === wsId);
                $('.advissor-error-block').hide();
                that.selectBranchFromMap(element, true);
            }
        });
    }

    innactiveSection(section) {
        $(section).find('.numberCircle').addClass('inactive');
    }

    bindCollapseElement() {
        var that = this;
        $('.collapse-element').on('click', function() {
            var id = $(this).attr('data-collapse');
            $('#collapseWorkshop_'+id).slideToggle(500, function () {});
        });
    }

    // We need to customize this!!
    handleLocationError(browserHasGeolocation, infoWindow) {
        $('#collapseWorkshop .branches-list-block #wf-total-list').html('');
        $('#collapseWorkshop #wf-map-branches-block').hide();
        $('#collapseWorkshop .branches-list-block').hide();
    }

    bindSearch() {
        var that = this;
        $('#btn-search-branches').on('click', function() {
            $('#wf-error-search').show();
            $('#wf-error-search .error').hide();
            $('#wf-error-search .error .error-msg').html('');
            $('.branch-select-container').html('');
            $('.branch-selected').hide();
            var geocoder = new google.maps.Geocoder();
            var lat = '';
            var lng = '';
            if($('#branches-searcher').length>0 && $('#branches-searcher').val()!='') {
                var code = $('#branches-searcher').val() +"," + $('#country-name').val();
                geocoder.geocode( { 'address': code}, function(results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                       lat = results[0].geometry.location.lat();
                       lng = results[0].geometry.location.lng();
                       that.getBranches({lat: lat, lng: lng}) 
                    } else {
                        $('#collapseWorkshop .branches-list-block #wf-total-list').html('');
                        $('#collapseWorkshop #wf-map-branches-block').hide();
                        $('#collapseWorkshop .branches-list-block').hide();
                        $('#wf-error-search .error').show();
                        $('#wf-error-search .error .error-msg').html($('#wf-branch-code-not-found').val());
                    }
                  });
            } else {
                $('#wf-error-search').show();
                $('#wf-error-search .error').show();
                $('#wf-error-search .error .error-msg').html($('#wf-branch-error-search').val());
                $('#collapseWorkshop .branches-list-block #wf-total-list').html('');
                $('#collapseWorkshop #wf-map-branches-block').hide();
                $('#collapseWorkshop .branches-list-block').hide();
            }
        });
    }

    bindSearchIntro() {
        $('#branches-searcher').on('keypress', function (e) {
            if(e.key === 13 || e.key === 'Enter'){
                $('#btn-search-branches').trigger("click");
            }
      });
    }
}

export { FormMaps }